import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import Loader from 'components/Loader'
import Layout from 'containers/Layout'
import EmbedUrl from 'containers/EmbedUrl'

import { fetchReports } from 'store/Reports/actions'
import {
  getCurrentReport,
  getIsLoadingReports,
  getReportsByVenue,
  getSelectedReportId
} from 'store/Reports/selectors'
import { getCurrentVenue, getAllVenuesEnabled } from 'store/Venues/selector'

export const Report = () => {
  const dispatch = useDispatch()

  const { label } = useSelector(getCurrentVenue)
  const allVenues = useSelector(getAllVenuesEnabled)
  const reports = useSelector(state => getReportsByVenue(state, allVenues ? 'allVenues' : label))
  const selectedReport = useSelector(getSelectedReportId)
  const isLoadingReports = useSelector(getIsLoadingReports)

  const firstReportID = reports?.[0]?.dashboardId ?? ''
  const reportId = !isEmpty(selectedReport) ? selectedReport : firstReportID
  const currentDashboard = useSelector(state =>
    getCurrentReport(state, reportId, allVenues ? 'allVenues' : label)
  )

  const isLoading = isLoadingReports

  useEffect(
    () => {
      dispatch(fetchReports())
    },
    [reportId, label]
  )

  return isLoading ? (
    <Loader />
  ) : (
    <Layout isSidebar mainContent={<EmbedUrl url={currentDashboard?.embedUrl} />} />
  )
}
